import { ApiFragment } from '@digihaven/shared';

import { Series } from '@common/entities/series/series.entity';

export const GetLastModifiedDate = (record: Series | ApiFragment) => {
    return record instanceof ApiFragment ? record.metadata.Administrative.LastModifiedDate : record.Status.LastModified;
};
